module.exports = __webpack_public_path__ + "static/media/mobile_nformacy_logo.c16a72ad.svg";